import { render, staticRenderFns } from "./LogsView.vue?vue&type=template&id=2dea83d3&"
import script from "./LogsView.vue?vue&type=script&lang=js&"
export * from "./LogsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports